// import { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// const AddDomains = () => {
//   const { id } = useParams(); // Get publisher ID from URL
//   const navigate = useNavigate();
//   const [domain, setDomain] = useState("");
//   const [name, setName] = useState(""); 
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/admin/addNewSite`,
//         {
//           account_id: id, // Publisher ID
//           name: name, // Domain name
//           domain: domain,
//           status: "0",
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//         }
//       );
//       console.log(response);
      
//       if (response.status === 201) {
//         setMessage("Domain added successfully!");
//         setDomain(""); // Reset input field after successful submission

//         // Redirect after 2 seconds
//         setTimeout(() => {
//           navigate("/publisher-list"); // Redirect to publisher list page
//         }, 2000);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         console.error("Unauthorized! Token might be expired.");
//         localStorage.removeItem("token");
//         navigate("/");
//       } else {
//         console.error("Error fetching data:", error);
//       }
//       setMessage(
//         error.response?.data?.message || "Failed to add domain. Try again!"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="mainContainer">
//     <div className="container mt-4">
//       <h2>Add Domain</h2>
//       {message && <div className="alert alert-info">{message}</div>}
//       <form onSubmit={handleSubmit}>
//         <div className="mb-3">
//           <label className="form-label">Domain Name :</label>
//           <input
//             type="text"
//             className="form-control"
//             value={domain}
//             onChange={(e) => setDomain(e.target.value)}
//             required
//             placeholder="Enter domain name"
//           />
//         </div>
//         <div className="mb-3">
//           <label className="form-label">Name :</label>
//           <input
//             type="text"
//             className="form-control"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             required
//             placeholder="Enter name"
//           />
//         </div>
//         <button type="submit" className="btn btn-success" disabled={loading}>
//           {loading ? "Adding..." : "Add Domain"}
//         </button>
//         <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>
//           Cancel
//         </button>
//       </form>
//     </div>
//     </section>
//   );
// };

// export default AddDomains;
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./addDomain.css";

const AddDomains = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [domain, setDomain] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!domain.trim() || !name.trim()) {
      setMessage("Please fill in all required fields.");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("");
    setMessageType("");

    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/addNewSite`,
        {
          account_id: id,
          name: name.trim(),
          domain: domain.trim(),
          status: "0",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 201) {
        setMessage("Domain added successfully!");
        setMessageType("success");

        setDomain("");
        setName("");

        setTimeout(() => {
          navigate(`/domain-list/${id}`);
        }, 1500);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");

        localStorage.removeItem("token");
        localStorage.removeItem("account_id");
        localStorage.removeItem("userRole");

        navigate("/");
        return;
      }

      console.error("Error adding domain:", error);

      setMessage(
        error.response?.data?.message ||
          "Failed to add domain. Please try again."
      );

      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="add-domain-page">
      <div className="add-domain-container">

        {/* =====================================
            PAGE HEADER
        ====================================== */}
        <div className="add-domain-header">

          <div className="add-domain-heading">
            <button
              type="button"
              className="back-button"
              onClick={() => navigate(-1)}
              aria-label="Go back"
            >
              ←
            </button>

            <div>
              <h1>Add Domain</h1>
              <p>
                Add a new domain to this publisher account.
              </p>
            </div>
          </div>

        </div>


        {/* =====================================
            ALERT MESSAGE
        ====================================== */}
        {message && (
          <div
            className={`add-domain-alert ${
              messageType === "success"
                ? "alert-success"
                : "alert-error"
            }`}
          >
            <span className="alert-icon">
              {messageType === "success" ? "✓" : "!"}
            </span>

            <span>{message}</span>
          </div>
        )}


        {/* =====================================
            FORM CARD
        ====================================== */}
        <div className="add-domain-card">

          <div className="add-domain-card-header">
            <div>
              <h2>Domain Information</h2>
              <p>
                Enter the details of the website you want to add.
              </p>
            </div>
          </div>


          <form
            onSubmit={handleSubmit}
            className="add-domain-form"
          >

            {/* DOMAIN */}
            <div className="form-field">

              <label htmlFor="domain">
                Domain Name
                <span className="required">*</span>
              </label>

              <input
                id="domain"
                type="text"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
                placeholder="https://example.com"
                required
                disabled={loading}
                autoComplete="url"
              />

              <span className="field-help">
                Enter the website domain associated with this publisher.
              </span>

            </div>


            {/* NAME */}
            <div className="form-field">

              <label htmlFor="name">
                Name
                <span className="required">*</span>
              </label>

              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter publisher or website name"
                required
                disabled={loading}
                autoComplete="organization"
              />

              <span className="field-help">
                Enter the name that should be displayed for this domain.
              </span>

            </div>


            {/* ACTIONS */}
            <div className="add-domain-actions">

              <button
                type="button"
                className="add-domain-cancel"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="add-domain-submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="button-spinner"></span>
                    Adding...
                  </>
                ) : (
                  <>
                    <span>+</span>
                    Add Domain
                  </>
                )}
              </button>

            </div>

          </form>

        </div>


        {/* =====================================
            BOTTOM NOTE
        ====================================== */}
        <div className="add-domain-note">
          <span>ⓘ</span>
          <p>
            Make sure the domain name is correct before adding it.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AddDomains;